import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { titleCase, padZero } from '../../utils';
import { salmon } from 'quantux-ui';

const PatientCard = (props) => {
  const styles = StyleSheet.create({
    cardContainer: {
      height: '72px',
      width: 'calc(100% - 16px)',
      background: '#003060',
      alignItems: 'center',
      marginLeft: '8px',
      padding: '4px'
    },
    details: {
      fontSize: '14px',
      lineHeight: '16px'
    }
  });

  const {
    patientFirstName,
    patientLastName,
    ssn1,
    ssn2,
    ssn3,
    userName = '',
    dobMonth,
    dobDate,
    dobYear,
    gender,
    patientAge,
    insuranceFlag = true,
    profileFlag = true,
    contactFlag = true
  } = props.data;

  return (
    <div className={`fx ${props.className} ${css(styles.cardContainer)}`}>
      {/* Patient Avatar */}
      <svg
        width="64"
        height="64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 0a2 2 0 0 0-2 2v60a2 2 0 0 0 2 2h60a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm43 19c0 6.64-5.36 12-12 12s-12-5.36-12-12S26.36 7 33 7s12 5.36 12 12ZM9 51.002c0-8 16-12.4 24-12.4s24 4.4 24 12.4v4H9v-4Z"
          fill="#96C8FF"
        />
      </svg>
      {/* <svg
        width="32"
        height="32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 0a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm20.5 9.5c0 3.32-2.68 6-6 6s-6-2.68-6-6 2.68-6 6-6 6 2.68 6 6Zm-18 16c0-4 8-6.2 12-6.2s12 2.2 12 6.2v2h-24v-2Z"
          fill="#96C8FF"
        />
      </svg> */}

      {/* Patient Data */}
      <div className={`ml-2 ${css(styles.details)}`}>
        {/* Display and Username */}
        <div className='fx'>
          <div>{`${titleCase(patientFirstName || '')} ${titleCase(patientLastName || '')}`}</div>
          {userName !== '' &&
            <div className='ml-2' style={{ color: 'white' }}>
              {`@${userName !== '' ? userName : ''}`}
            </div>
          }
        </div>
        {/* SSN and DOB */}
        <div>
          <span style={{ color: ssn1.length === 3 ? '' : salmon[500] }}>
            {`(${ssn1.length > 0 ? 'XXX' : '???'}`}
          </span>-
          <span style={{ color: ssn2.length === 2 ? '' : salmon[500] }}>
            {`${ssn2.length > 0 ? 'XX' : '??'}`}
          </span>-
          <span style={{ color: ssn3.length === 4 ? '' : salmon[500] }}>
            {`${ssn3.length > 0 ? ssn3 : '????'})`}
          </span>
          {/* <span>
            {`(${ssn1.length > 0 ? 'XXX' : '???'}-${ssn2.length > 0 ? 'XX' : '??'}-${ssn3.length > 0 ? ssn3 : '????'})`}
          </span> */}
          &nbsp;
          <span>
            {`${padZero(dobMonth + 1)}/${padZero(dobDate)}/${dobYear}, ${patientAge}, ${gender.toLowerCase() === 'male' ? 'M' : 'F'}`}
          </span>
        </div>
        {/* Flag Icons */}
        <div className='fx fx__v-center mt-1'>
          {/* Profile flag */}
          {profileFlag &&
            <div>
              <svg
                width="16"
                height="16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.997 0H0v16h16V0h-.003Zm0 0v16l-5.622-8 5.622-8Z"
                  fill="#FF6060"
                />
              </svg>
            </div>
          }
          {/* Insurance flag */}
          {insuranceFlag &&
            <div className='ml-2'>
              <svg
                width="18"
                height="20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 2.857 8.571 0l8.572 2.857v8.572A8.57 8.57 0 0 1 8.57 20 8.57 8.57 0 0 1 0 11.429V2.857Zm8.574 15.536a6.965 6.965 0 0 0 6.964-6.964V4.063L8.574 1.607 1.609 4.063v7.366a6.965 6.965 0 0 0 6.965 6.964Z"
                  fill="#FF6060"
                />
              </svg>
            </div>
          }
          {/* Patient Contact(s) flag */}
          {contactFlag &&
            <div className='ml-2'>
              <svg
                width="21"
                height="20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.482 6.83H.804a.803.803 0 1 1 0-1.607h2.678a.803.803 0 1 1 0 1.607Zm0 6.383a.803.803 0 1 1 0 1.607H.804a.803.803 0 1 1 0-1.607h2.678Z" fill="#FF6060" /><path d="M18.394 0H3.037C2.148 0 1.43.719 1.43 1.607v1.25a.803.803 0 1 0 1.607 0v-1.25h15.357v16.786H3.037v-1.206h-.002l.002-.044a.803.803 0 1 0-1.605.044H1.43v1.206c0 .888.718 1.607 1.607 1.607h15.357c.888 0 1.607-.719 1.607-1.607V1.607C20.001.72 19.282 0 18.394 0Z" fill="#FF6060" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.422 11.607a3.666 3.666 0 0 1-3.66-3.661 3.666 3.666 0 0 1 3.66-3.66 3.666 3.666 0 0 1 3.661 3.66 3.666 3.666 0 0 1-3.66 3.66ZM.804 10.826h2.678a.803.803 0 1 0 0-1.607H.804a.803.803 0 1 0 0 1.607Zm8.563-2.88c0-1.132.922-2.053 2.054-2.053 1.132 0 2.053.921 2.053 2.053A2.057 2.057 0 0 1 11.421 10a2.057 2.057 0 0 1-2.054-2.054Z" fill="#FF6060" /><path d="M15.63 15.714a.8.8 0 0 1-.788-.654 3.485 3.485 0 0 0-6.843 0 .804.804 0 0 1-1.579-.299 5.09 5.09 0 0 1 10 0 .804.804 0 0 1-.79.953Z"
                    fill="#FF6060"
                />
              </svg>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

PatientCard.defaultProps = {
  className: 'mt-4'
};

export default PatientCard;
